import { types } from "../action-types";

const initialState = {
  loading: false,
  success: false,
  error: false,
  response: false,
};

const viewIncrementReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.VIEW_INCREMENT_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.VIEW_INCREMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        response: action.payload,
      };
    case types.VIEW_INCREMENT_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
        response: [],
      };
    default:
      return state;
  }
};
export default viewIncrementReducer;
